var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42105 11.9531H3.78947V21.25H6.42105V11.9531ZM14.3158 11.9531H11.6842V21.25H14.3158V11.9531ZM25.5 23.9062H0.5V26.5625H25.5V23.9062ZM22.2105 11.9531H19.5789V21.25H22.2105V11.9531ZM13 3.00156L19.8553 6.64062H6.14474L13 3.00156ZM13 0L0.5 6.64062V9.29688H25.5V6.64062L13 0Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtIcon);
export default __webpack_public_path__ + "static/media/artIcon.10def3376bb593876bd65d849c2f6bd9.svg";
export { ForwardRef as ReactComponent };